import DialogCustom from "../../../../../DialogCustom/DialogCustom";
import FindDeviceContent from "../FindDeviceContent/FindDeviceContent";

interface MobileFindDeviceProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileFindDevice = ({ isOpen, onClose }: MobileFindDeviceProps) => {
  return (
    <DialogCustom
      closeAfterTransition={false} // prevents from aria-hidden warning on closing dialog first time after render
      noPadding
      open={isOpen}
      close={onClose}
      data-testid="mobile-find-device-dialog"
      disableRestoreFocus
    >
      <FindDeviceContent close={onClose} />
    </DialogCustom>
  );
};

export default MobileFindDevice;
